import { paymentsApi } from '.';

export interface PaypalCreateRequest {
  client: string,
  account_identifier: string,
  amount: number,
  order_reference: string,
  giftaid: number,
  campaign: string,
  currency: string,
  transSource: string,
  transSourceUrl: string,
  transType: string,
  cartId?: string,
}

export interface PaypalCreateData {
  account_identifier: string,
  provider_reference: string,
  transactionId: string,
}

export interface PaypalCreateResponse {
  data: PaypalCreateData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    paypalCreate: builder.mutation<PaypalCreateResponse, PaypalCreateRequest>({
      query: body => ({
        url: 'provider/paypal/create',
        method: 'POST',
        body,
      })
    })
  })
});

export const { usePaypalCreateMutation } = extendedPaymentsApi;
